import React, { useEffect, useState } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { BASE_URL } from "../utils/constants";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import Swal from "sweetalert2";
import axios from "axios";
import { PrintGrades } from "utils/helperFunc";
import Select from "react-select";
import parse from 'html-react-parser';
const ProgressReport = () => {
  const [progressData, setProgessData] = useState([]);
  const [yearId, setYearId] = useState("");
  const [academicYearOptions, setAcademicYearOptions] = useState([]);

  const [academicYearData, setAcademicYearData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [report ,setReport] = useState("");
  useEffect(() => {
    try {
      Swal.showLoading();
      axios
        .post(`${BASE_URL}/student/getcourses.php`, {})
        .then((res) => {
          const responseData = res.data?.data || {};
          const progressReport = responseData.data || {};
          setErrorMsg(progressReport.errorMsg || "");
          setProgessData(responseData.grades || []);
          setAcademicYearData(responseData.academicyears || []);
          setYearId(responseData.year_id || "");
          setReport(typeof progressReport.report === "string" ? progressReport.report : "");
          const newOptions = (responseData.academicyears || []).map((year) => {
            return { value: year.id, label: `${year.academicyear}` };
          });
          setAcademicYearOptions(newOptions);

          Swal.close();
        });
    } catch (e) {

      Swal.fire("Error while getting courses!", "", "error");
    }
  }, []);


  const roundNumber = (number) => {
    let modifiedNumber = number;
    if (number % 1 != 0) {
      modifiedNumber = parseFloat(number).toFixed(2);
    }

    if (isNaN(modifiedNumber)) {
      return "NA";
    } else {
      return modifiedNumber;
    }
  };
  const handleSelectyear = (e) => {
    setYearId(e.value);
    axios
      .post(`${BASE_URL}/student/getcourses.php`, {
        year_id: e.value,
      })
      .then((res) => {
        const responseData = res.data?.data || {};
        const progressReport = responseData.data || {};
        setErrorMsg(progressReport.errorMsg || "");
        setProgessData(responseData.grades || []);
        setReport(typeof progressReport.report === "string" ? progressReport.report : "");
        // setEnrollmentData(res.data.data.enrollment);
        setAcademicYearData(responseData.academicyears || []);
        setYearId(responseData.year_id || "");
        const newOptions = (responseData.academicyears || []).map((year) => {
          return { value: year.id, label: `${year.academicyear}` };
        });
        setAcademicYearOptions(newOptions);
      });
  };

  const getGradeLable = (grade) => {
    let gradeLable = "";
    let finalGrade = +grade;
    if (finalGrade >= 90) gradeLable = "A";
    else if (finalGrade >= 80 && finalGrade < 90) gradeLable = "B";
    else if (finalGrade >= 70 && finalGrade < 80) gradeLable = "C";
    else if (finalGrade >= 60 && finalGrade < 70) gradeLable = "D";
    else if (finalGrade <= 59) gradeLable = "F";
    else gradeLable = "NA";
    return gradeLable;
  };

  const printGrades = (year_id) => {
    PrintGrades(year_id);
  };
  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader>
                <h4 className="title">Progress Report</h4>
              </CardHeader>
              <CardBody className="all-icons">
                <button
                  className="btn btn-primary w-25"
                  onClick={() => {
                    printGrades(yearId);
                  }}
                >
                  Print
                </button>

                <Select
                  closeMenuOnSelect={true}
                  options={academicYearOptions}
                  onChange={(e) => {
                    handleSelectyear(e);
                  }}
                  value={academicYearOptions.find((f) => {
                    return f.value == yearId;
                  })}
                />

                {errorMsg == "" || errorMsg == undefined ? (
                 (report ? parse(report) : null)
                 ) : (
                  <div className="text-center text-danger mt-3 font-weight-bold">
                    {errorMsg}
                  </div>
                )}

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProgressReport;
